import React from 'react';
import PropTypes from 'prop-types';

import * as styles from './styles/styles.module.scss';
import HomeSearchBar from '../../search/HomeSearchBar';
import RotatingHero from '../../shared/RotatingHero';
import { isToday, betweenHours } from '../../../utils/time_helpers';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { DESKTOP_BREAKPOINT } from '../../../utils/constants/breakpoints';
import { contextPropTypes } from '../../../proptypes/shared';
import { LanguageSupportUtil } from '../../../utils/language_support_util';

const {
  strings: {
    HOME_PAGE: {
      HOME_HEADER: { EXPLORE_NEARYBY_TRAILS, FIND_YOUR_NEXT_TRAIL }
    }
  }
} = StringConstantsMixin;

const FIRST_NAME_PLACEHOLDER = '{first_name}';

const chooseGreeting = (greetings, currentUser, greetingIndex) => {
  if (!(currentUser && greetings)) {
    return FIND_YOUR_NEXT_TRAIL;
  }

  let text = '';
  greetings.forEach(greet => {
    if (text.length === 0) {
      if (greet.event_start_date_time && isToday(greet.event_start_date_time)) {
        text = greet.generic_title[0];
      } else if (greet.daily_start_time && greet.daily_end_time && betweenHours(greet.daily_start_time, greet.daily_end_time)) {
        text = greet.custom_title[greetingIndex];
      }
    }
  });

  if (currentUser && currentUser.firstName && text.includes('{first_name}')) {
    text = text.replace(FIRST_NAME_PLACEHOLDER, currentUser.firstName);
  }

  return text;
};

const HomeHeader = ({ windowWidth, latLng, context, greetings, heroData }) => {
  const isCurrentUser = context.currentUser !== null;

  const deviceType = context.mobileBrowser || (windowWidth && windowWidth <= DESKTOP_BREAKPOINT) ? 'mobile' : 'desktop';

  const headerText = chooseGreeting(greetings, context.currentUser, heroData.greetingIndex);

  if (isCurrentUser) {
    const buttonContainerStyle = deviceType === 'mobile' ? { marginBottom: 36 } : null;

    return (
      <RotatingHero duration={6000} images={heroData.images} className={styles.loggedInContainer} buttonContainerStyle={buttonContainerStyle}>
        <h1 className={`${styles.header} xlate-none`}>{headerText}</h1>
        <div className={`${styles.searchBarContainer} ${styles.loggedInSearchContainer}`}>
          <HomeSearchBar windowWidth={windowWidth} latLng={latLng} context={context} />
        </div>
      </RotatingHero>
    );
  }

  return (
    <RotatingHero duration={6000} images={heroData.images} className={styles.container}>
      <div className={styles.contentContainer}>
        <h1 className={`${styles.header} xlate-none`}>{headerText}</h1>
        <div className={styles.searchBarContainer}>
          <HomeSearchBar windowWidth={windowWidth} latLng={latLng} context={context} />
        </div>
        <div className={styles.exploreLink}>
          <a href={LanguageSupportUtil.wrapUrlSafe('/explore?ref=homepage_explore_homeheader', context.languageRegionCode)}>
            {EXPLORE_NEARYBY_TRAILS}
          </a>
        </div>
      </div>
    </RotatingHero>
  );
};

HomeHeader.propTypes = {
  context: contextPropTypes.isRequired,
  greetings: PropTypes.arrayOf(PropTypes.object),
  heroData: PropTypes.shape({
    greetingIndex: PropTypes.number
  }).isRequired,
  latLng: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])).isRequired,
  windowWidth: PropTypes.number
};

HomeHeader.defaultProps = {
  greetings: null,
  windowWidth: null
};

export default HomeHeader;
